import Vue from 'vue'
import Raven from 'raven-js';   //sentry
import RavenVue from 'raven-js/plugins/vue';

if (process.env.NODE_ENV == 'production') {
  Raven
  .config('https://20f575c3aa8349b985d774cd294f7cec@sentry.julanling.com/810', {
    captureUnhandledRejections: false
  })
  .addPlugin(RavenVue, Vue)
  .install();
}

